import { Center } from '@chakra-ui/react'
import onboardingPigbank from 'assets/images/svgs/onboarding-pigbank.svg'
import history from "infra/helpers/history";
import CardOnboarding from "../components/card-onboarding";

function SegundoPasso() {
    return(
        <Center w="100vw" h="100vh">
            <CardOnboarding 
                imageSrc={ onboardingPigbank }
                headingText="Saúde financeira"
                subheadText="Veja suas despesas e receitas, moradores inadimplentes, acordos realizados, previsão orçamentária… Tudo para agilizar sua tomada decisão."
                onNext={() => history.push('terceiro-passo')}
                onBack={() => history.goBack()}
                onPular={ true }
                step={2}
            />
        </Center>
    )
}

export default SegundoPasso;